import { EQUALISATIONS } from 'adminConstants/routes';
import SuccessPage from 'components/new/SuccessPage';

const ProcessCloseSuccess: React.FC = () => {
  return (
    <SuccessPage
      title="The vehicle's first close has been processed successfully."
      content=""
      primaryButton={{
        label: 'Return to Close & Equalise',
        link: EQUALISATIONS,
      }}
    />
  );
};

export default ProcessCloseSuccess;
